import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FeatureCasinoCrash = styled(Box)(({ theme }) => ({}));

export const CasinoCrashGameBox = styled('main')(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing(1),

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
}));

export const CasinoCrashGameBoxItemLeft = styled('div')(({ theme }) => ({
  flex: 1,
  marginRight: theme.spacing(2),
  // maxWidth: '794px',
  [theme.breakpoints.down('lg')]: {
    maxWidth: 'none',
    width: '100%',
    padding: 'none',
    marginRight: 'none',
  },
}));

export const CasinoCrashGameBoxItemRight = styled('div')(({ theme }) => ({
  width: '282px',
  // minWidth: '282px',
  flex: 1,
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    padding: 'none',
    marginRight: 'none',
    maxWidth: 'none',
  },
}));

export const CasinoCrashSettingBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  background: theme.palette.grey['900'],
  padding: theme.spacing(3),
}));

export const GameWrapper = styled(Box)(({ theme }) => ({
  // border: '1px solid rgba(255, 255, 255, 0.12)',
  // paddingTop: '121px',
  borderRadius: '8px 8px 0 0',
  overflow: 'hidden',
  background: theme.palette.bg.main,
  paddingRight: theme.spacing(1),
  position: 'relative',
  backgroundImage: `url('/assets/images/casino/crash/crash-bg-new.png')`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100%',
  [theme.breakpoints.down('lg')]: {
    paddingTop: 0,
  },
}));

// SettingBoxConfig, SettingBoxLogo, SettingBoxFairness
export const SettingBoxConfig = styled(Box)(({ theme }) => ({
  width: '100%',
  // background: theme.palette.grey['900'],
}));

export const SettingBoxLogo = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
}));

export const SettingBoxFairness = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
}));

export const GameBoxWrapper = styled(Box)(({ theme }) => ({
  minHeight: '388px', //这里设置最小高度是为了让游戏盒子在没有游戏的时候也能够撑起来
  [theme.breakpoints.down('md')]: {
    minHeight: '250px',
  },
}));
